export const isDevelopment = process.env.NODE_ENV !== "production";

export const isStaging =
  !isDevelopment && /staging\.sportrecs\.net$/.test(document.location.hostname);

export const isProduction = !isStaging && !isDevelopment;

export const isPartner = /^\/partner/.test(document.location.pathname);
export const isDocument = /^\/document\//.test(document.location.pathname);
export const isWhitelabelAdmin = /^\/whitelabel(\/|$)/.test(
  document.location.pathname
);

export const isVigram = process.env.REACT_APP_INSTANCE === "vigram";
export const isPolkasoft = process.env.REACT_APP_INSTANCE === "polkasoft";

export const isAdmin =
  !isPartner &&
  !isDocument &&
  !isWhitelabelAdmin &&
  (/^cp/.test(document.location.hostname) || isDevelopment);

// console.log({
//   isDevelopment,
//   isStaging,
//   isProduction,
//   isPartner,
//   isDocument,
//   isAdmin,
//   isVigram,
//   isPolkasoft
// });
